// ##### 23-10-18 Komarov
import { createMedia } from "@artsy/fresnel";
import { breakpoints, interactions } from "../../server/helpers/MediaConfig";

export const { MediaContextProvider, Media } = createMedia({
  // breakpoints values can be either strings or integers
  breakpoints,
  interactions,
});
